import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IAttachmentsFilesDTO, ITests } from 'src/app/_interfaces/medical-tests/i-medical-test-details';
import { GenericResponse, SuccessResponse } from 'src/app/_models/response.model';

@Injectable({
  providedIn: 'root'
})
export class EhrTestResultsFilesServiceService {

  addEhrTestResultsFilesByAdminUrl: string = 'api/AdminEhrTestResultsFiles/AddEhrTestResultsFilesByAdmin';
  deleteMedicalTestAddedByAdminUrl: string = 'api/AdminEhrTestResultsFiles/DeleteMedicalTestAddedByAdmin';
  updateEhrTestResultsFilesByAdminUrl: string = 'api/AdminEhrTestResultsFiles/UpdateEhrTestResultsFilesByAdmin';
  getTestsByTypeIdUrl: string = 'api/Tests/GetTestsByTypeId?typeId=';
  constructor(private http: HttpClient) { }

  addEhrTestResultsFilesByAdmin(patientId, testDate, files, testTypeId, testsIds, doctorName): Observable<SuccessResponse> {
    const formData = new FormData();
    if (patientId) formData.append('patientId', patientId);
    if (testDate) formData.append('title', testDate);
    if (testTypeId) formData.append('testTypeId', testTypeId);
    if (doctorName) formData.append('doctorName', doctorName);
    if (testsIds) testsIds.forEach(id => formData.append('testIds', id.toString()));
    files.forEach((file) => { formData.append('files', file); })
    return this.http.post<SuccessResponse>(this.addEhrTestResultsFilesByAdminUrl, formData);
  }

  deleteTestResultFilesAddedByAdmin(ehrTransactionId, fileId): Observable<SuccessResponse> {
    return this.http.put<SuccessResponse>(this.deleteMedicalTestAddedByAdminUrl, { ehrTransactionId, filePaths: fileId });
  }

  updateEhrTestResultsFilesByAdmin(ehrTransactionId, testDate, files): Observable<GenericResponse<IAttachmentsFilesDTO>> {
    const formData = new FormData();
    formData.append('ehrTransactionId', ehrTransactionId);
    formData.append('title', testDate);
    files.forEach((file) => { formData.append('files', file); })

    return this.http.put<GenericResponse<IAttachmentsFilesDTO>>(this.updateEhrTestResultsFilesByAdminUrl, formData);
  }
  getTestsByTypeId(id: number): Observable<GenericResponse<{ tests: ITests[] }>> {
    return this.http.get<GenericResponse<{ tests: ITests[] }>>(`${this.getTestsByTypeIdUrl + id}`)
  }

}
